// Page Builder building blocks of a shop "About us" page (hero cards, headings, paragraphs, image
// rows, badge grids). Shared by the Seller About page (lakayUser/ShopAboutPage.jsx) and the Provider
// About page (dropshippingInterne/storefront/providerAboutDoc.js): same visual language, each shop
// type writes its OWN content from its OWN data.
export const makeNodeId = (prefix) =>
  `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;

export const aboutPlaceholderImg = (w, h, bg, fg, label) =>
  `https://placehold.co/${w}x${h}/${bg}/${fg}?text=${encodeURIComponent(label)}`;

export const aboutCard = (children, extraStyle = {}) => ({
  id: makeNodeId("about-card"),
  type: "container",
  style: {
    padding: "32px",
    border: "1px solid #e5e7eb",
    borderRadius: "20px",
    background: "#ffffff",
    marginBottom: "24px",
    ...extraStyle,
  },
  children,
});

export const aboutHeading = (text, opts = {}) => ({
  id: makeNodeId("about-heading"),
  type: "heading",
  tag: opts.tag || "h2",
  text,
  style: {
    margin: "0 0 14px",
    color: opts.color || "#1f2937",
    fontSize: opts.size || "26px",
    fontWeight: "800",
    textAlign: opts.align || "left",
    ...(opts.style || {}),
  },
});

export const aboutText = (text, extraStyle = {}) => ({
  id: makeNodeId("about-text"),
  type: "text",
  tag: "p",
  text,
  style: {
    margin: "0 0 14px",
    color: "#4b5563",
    fontSize: "15px",
    lineHeight: "1.85",
    whiteSpace: "pre-line",
    ...extraStyle,
  },
});

export const aboutImage = (label, opts = {}) => ({
  id: makeNodeId("about-image"),
  type: "image",
  src: aboutPlaceholderImg(opts.w || 1200, opts.h || 360, opts.bg || "e0f2fe", opts.fg || "0284c7", label),
  alt: label,
  style: {
    width: "100%",
    display: "block",
    aspectRatio: opts.ratio || "16 / 5",
    objectFit: "cover",
    borderRadius: opts.radius || "16px",
    marginBottom: opts.mb ?? "16px",
    ...(opts.style || {}),
  },
});

export const aboutGalleryRow = (labels, opts = {}) => ({
  id: makeNodeId("about-gallery-row"),
  type: "row",
  style: { display: "flex", flexWrap: "wrap", gap: "16px", marginBottom: "16px" },
  children: labels.map((label) => ({
    id: makeNodeId("about-gallery-img"),
    type: "image",
    src: aboutPlaceholderImg(opts.w || 420, opts.h || 320, opts.bg || "e0f2fe", opts.fg || "0284c7", label),
    alt: label,
    style: {
      flex: "1 1 220px",
      width: "100%",
      display: "block",
      aspectRatio: opts.ratio || "4 / 3",
      objectFit: "cover",
      borderRadius: "14px",
    },
  })),
});

export const aboutBadgeGrid = (items, opts = {}) => ({
  id: makeNodeId("about-badge-grid"),
  type: "row",
  style: { display: "flex", flexWrap: "wrap", gap: "14px" },
  children: items.map((it) => ({
    id: makeNodeId("about-badge"),
    type: "container",
    style: {
      flex: opts.flex || "1 1 180px",
      padding: "20px 16px",
      borderRadius: "14px",
      background: opts.bg || "#f8fafc",
      border: "1px solid #e5e7eb",
      textAlign: "center",
    },
    children: [
      { id: makeNodeId("about-badge-icon"), type: "text", tag: "div", text: it.icon, style: { fontSize: "30px", marginBottom: "8px" } },
      { id: makeNodeId("about-badge-title"), type: "heading", tag: "h4", text: it.title, style: { margin: "0 0 4px", color: "#1f2937", fontSize: "14px", fontWeight: "800" } },
      ...(it.text ? [{ id: makeNodeId("about-badge-text"), type: "text", tag: "p", text: it.text, style: { margin: 0, color: "#6b7280", fontSize: "12.5px", lineHeight: "1.6" } }] : []),
    ],
  })),
});
